/* eslint-disable indent */
import React from 'react';

import i18n from 'i18';

// @mui
import { TextField, MenuItem, Typography, Box } from '@mui/material';

export default class DialogItemsField extends React.Component {
    onChange(event) {
        this.props.onChange(event.target.name, event.target.value);
    }

    render() {
        // field, value, onChange
        const id = this.props.field.id;

        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">
                    {translatedLabel + requiredLabel}
                </Typography>
                <TextField
                    select
                    margin="dense"
                    id={id}
                    name={id}
                    value={this.props.value || ''}
                    sx={{
                        '& .MuiSelect-select .notranslate::after':
                            placeholderLabel
                                ? {
                                      content: `"${placeholderLabel}"`,
                                      opacity: 0.7
                                  }
                                : {}
                    }}
                    InputProps={{
                        inputProps: {
                            MenuProps: {
                                PaperProps: {
                                    style: {
                                        maxHeight: 200
                                    }
                                }
                            }
                        }
                    }}
                    fullWidth
                    onChange={(event) => this.onChange(event)}
                >
                    {this.props.field.items.map((item) => (
                        <MenuItem key={item} value={item}>
                            {i18n.t(`enums.${item}`)}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
        );
    }
}
